module.exports = __webpack_public_path__ + "img/blu_monkey_phuket_town.66cec7a8.jpg";